///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectCurrentCustomerId } from '../shared/store/customerAccordionStore/accordion.selectors';

@Component({
    selector: 'winde-projects-engineering-panel',
    templateUrl: './projects-eng.component.html',
    styleUrls: ['projects.scss'],
    standalone: false
})
export class GtthProjectsEngComponent {
    public readonly customersBadgeAttribute = 'numberOfProjects';
    public readonly baseUrl = 'project-eng';
    public selectedCustomerId$ = this.store.select(selectCurrentCustomerId);

    constructor(private readonly store: Store) {}
}
